import axios from "axios";

const API = axios.create({
    // baseURL: "http://127.0.0.1:8000",
    baseURL: "https://api.mealno.in",
    timeout: 15000,
    headers: {
        "Content-Type": "application/json",
    },
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// ==========================
// Contact APIs
// ==========================

export const sendContactMessage = async(data) => {
    const response = await API.post("/api/v1/contact", data);
    return response.data;
};

// ==========================
// App Review APIs
// ==========================

export const sendAppReview = async(data) => {
    const response = await API.post("/api/v1/app-review", data);
    return response.data;
};

export default API;